import { render, staticRenderFns } from "./RequestsWaitingForApproval.vue?vue&type=template&id=2af42c9b&scoped=true"
import script from "./RequestsWaitingForApproval.vue?vue&type=script&lang=js"
export * from "./RequestsWaitingForApproval.vue?vue&type=script&lang=js"
import style0 from "./RequestsWaitingForApproval.vue?vue&type=style&index=0&id=2af42c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af42c9b",
  null
  
)

export default component.exports